import axios from 'axios';
// config
import { HOST_API_KEY } from '../config';

// ----------------------------------------------------------------------

// const axiosInstance = axios.create({ baseURL: 'https://api-dev-minimal-v4.vercel.app/' || HOST_API_KEY });
const axiosInstance = axios.create({ baseURL: 'http://localhost:3000/api/v1/' || HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
